

export const poolData = {
  UserPoolId: 'us-east-1_XXXXXXX',
  ClientId: 'XXXXXXXXXXXXXXXXXXXX',
};